import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ButtonItem from '../components/ButtonItem';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

function ArtistViewPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [artists, setArtists] = useState([]);

  const params = new URLSearchParams(location.search);
  const page = params.get('page');
  const search = params.get('search');


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/artist/${id}`
        );
        setArtists(response.data);
      } catch (error) {
        console.error('서버 접속 에러:', error);
      }
    };
    fetchData();
  }, [id]);

  // 아티스트 삭제 버튼
  const deleteArtist = async () => {
    if (window.confirm('아티스트를 삭제하시겠습니까?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/artist/${id}`);
        if (window.confirm('아티스트를 삭제하였습니다.')) {
          navigate('/Artists');
        }
      } catch (error) {
        console.error('서버 접속 에러:', error);
      }
    }
  };

  return (
    <>
        <div className="flex mb-8 justify-center items-center">
          <div className="text-xl sm:text-2xl font-bold text-white tracking-tight">
            <span>아티스트 상세정보</span>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="w-[90%] max-w-[650px] space-y-6">
            {/* 프로필 이미지 Url */}
            <div>
              <label className="block font-semibold mb-1">
                프로필 이미지 Url
              </label>
              <input
                type="text"
                value={artists.image || ''}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                readOnly
              />
              <img
                src={
                  artists.image ||
                  'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
                }
                alt={artists.nameKr}
                className="w-[200px] h-[200px] rounded-full object-cover mx-auto shadow border border-white/[0.08] mt-2"
              />
            </div>

            {/* 아티스트명 */}
            <div>
              <label className="block font-semibold mb-1">아티스트명</label>
              <input
                type="text"
                value={artists.nameKr || ''}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-white/[0.03] text-slate-300 focus:outline-none"
                readOnly
              />
            </div>
          </div>
        </div>

        <div className="w-full flex justify-end items-center mt-5">
          <ButtonItem
            className="mr-2"
            text="목록"
            color="gray"
            onClick={() => {
              const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
              navigate(`/Artists?page=${page}${searchParam}`);
            }}
          />
          <ButtonItem
            className="mr-2"
            text="삭제"
            color="red"
            onClick={deleteArtist}
          />
          <ButtonItem
            text="수정"
            color="blue"
            onClick={() => {
              const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
              navigate(`/Artist/Modify/${id}?page=${page}${searchParam}`);
            }}
          />
        </div>
    </>
  );
}

export default ArtistViewPage;
